var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.giftInterface.cta_kind && _vm.linkIsValid ? "a" : "div",
    {
      tag: "component",
      staticClass:
        "gift-card d-inline-flex flex-column justify-content-between",
      attrs: {
        href:
          _vm.giftInterface.cta_kind && _vm.linkIsValid
            ? _vm.giftInterface.cta_kind === "link"
              ? "/" + _vm.giftInterface.cta_link
              : _vm.route("nl.category", {
                  slug: _vm.giftInterface.cta_category.slug
                })
            : null
      }
    },
    [
      _c("div", { staticClass: "position-relative" }, [
        _c("div", { ref: "card", staticClass: "media-container mb-12" }, [
          _c(
            "div",
            {
              ref: "ar",
              staticClass: "ar",
              style: {
                "padding-top": _vm.fixedHeight
                  ? _vm.fixedHeight + "px"
                  : (_vm.arHeight / _vm.arWidth) * 100 + "%"
              }
            },
            [
              _c(
                "div",
                { staticClass: "images" },
                [
                  _vm.giftInterface.image
                    ? [
                        _c("img", {
                          ref: "primary",
                          staticClass: "primary-image",
                          attrs: {
                            src: _vm.giftInterface.image.sizes.medium_large,
                            alt: _vm.giftInterface.title
                          }
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "title lh-1" }, [
          _vm._v(_vm._s(_vm.giftInterface.title))
        ]),
        _vm._v(" "),
        _vm.giftInterface.description
          ? _c(
              "p",
              {
                staticClass: "text-dark font-weight-light small mt-8 subtitle"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.giftInterface.description) +
                    "\n        "
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.giftInterface.cta_kind != null &&
      _vm.giftInterface.cta_kind != "" &&
      _vm.linkIsValid
        ? _c(
            "button",
            { staticClass: "btn btn-accent mt-32 align-self-start" },
            [
              _vm._v(_vm._s(_vm.giftInterface.cta) + " "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.svg("arrow-right", "arrow-right"))
                }
              })
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }